export default __webpack_public_path__ + "static/media/planet.e4ed83af.png";